import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { getAllPaymentByUserId } from '../../../redux/actions/payment';
import { PropertyListItem } from '../../../components/PropertyListItem';
import { PropertyItem } from '../../../components/PropertyItem';
import { formatDateTime } from '../../../common/formatDateText';
import { Loading } from '../../../components/loading/Loading';

export const PaymentHistoryById = ({ action = false }) => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const params = useParams();
    const { userId } = params;

    useEffect(() => {
        dispatch(getAllPaymentByUserId(userId))
    }, [userId, dispatch]);

    const { paymentsByUser, loading } = useSelector((state) => state.payment);

    return (

        <div className='w-full flex flex-col gap-4 p-2 md:p-4'>
            <div>
                <h1 className='font-bold text-[1.3rem]'>Historial de pagos</h1>
            </div>
            <div className='w-full px-4 h-[500px] md:h-[calc(100vh-100px)] overflow-y-scroll bg-slate-100 rounded-md'>
                {
                    loading ? (
                        <Loading />
                    ) : (
                        <>
                            {
                                paymentsByUser && paymentsByUser.length > 0
                                    ? paymentsByUser.map(({ id, paymentType, validatedBy, status, amount, formatCreatedAt }) => (
                                        <div
                                            className='flex flex-col border-[1px] bg-white border-gray-200 rounded-lg p-4 my-4'
                                            key={id}
                                        >
                                            <PropertyListItem>
                                                <PropertyItem
                                                    title={`Ultima actualización`}
                                                    description={formatCreatedAt ? formatDateTime(formatCreatedAt) : '-'}
                                                    positionTile='md:text-left'
                                                    capitalize={true}
                                                />
                                                <PropertyItem
                                                    title={`Estatus del pago`}
                                                    description={status ? status : '-'}
                                                    positionTile='md:text-left'
                                                    capitalize={true}
                                                />
                                                <PropertyItem
                                                    title={`Monto del pago`}
                                                    description={amount ? `$ ${amount}` : `$ 0`}
                                                    positionTile='md:text-left'
                                                />
                                                <PropertyItem
                                                    title={`Tipo de pago`}
                                                    description={paymentType ? paymentType : '-'}
                                                    positionTile='md:text-left'
                                                    capitalize={true}
                                                />
                                                <PropertyItem
                                                    title={`Pago validado por`}
                                                    description={validatedBy ? validatedBy : '-'}
                                                    positionTile='md:text-left'
                                                    capitalize={true}
                                                />
                                            </PropertyListItem>
                                            {
                                                action && (
                                                    <div className='w-full '>
                                                        <div className='w-full flex justify-end mt-4'>
                                                            {
                                                                status === 'validado'
                                                                    ? <Link
                                                                        className='rounded-lg transition py-2 px-3  font-semibold text-md text-white text-center bg-sky-600 hover:bg-sky-800'
                                                                        to={`/detalle-pago/${id}`}
                                                                    >
                                                                        Detalle del pago
                                                                    </Link>
                                                                    : <Link
                                                                        className='rounded-lg transition py-2 px-3  font-semibold text-md text-white text-center bg-orange-500 hover:bg-orange-700'
                                                                        to={`/modificar-pago/${id}`}
                                                                    >
                                                                        Modificar pago
                                                                    </Link>
                                                            }
                                                        </div>
                                                    </div>
                                                )
                                            }

                                        </div>
                                    ))
                                    : <p className='p-4 text-gray-500'>No hay registro de pagos</p>
                            }
                        </>
                    )

                }
            </div>
        </div>
    )
}
